import { api } from '@api'
import { CommonTicketForm, Ticket } from '@types'

interface GetTicketsResponse {
  tickets: Ticket[]
}

const createTicket = async (payload: CommonTicketForm) => {
  const response = await api.post<GetTicketsResponse>('/tickets', { ticket: payload })

  return response.data
}

export const TicketsApi = { createTicket }
